<template>
  <div class="flex flex-wrap gap-12">
    <RefundButton
      v-if="actions.isRefundAllowed"
      :isCustomerBlocked="actions.isCustomerBlocked"
      :isRefundDisabled="actions.isRefundDisabled"
      @click="handleStartRefundFlow"
    />
    <RevButton
      v-if="actions.isShipBackToCustomerAllowed"
      size="small"
      variant="secondary"
      @click="handleStartShipBackFlow"
    >
      {{ i18n(translations.shipBackToCustomer) }}
    </RevButton>

    <RevButton
      v-if="actions.isReportProblemAllowed"
      :disabled="actions.isReportProblemDisabled"
      size="small"
      variant="secondary"
      @click="handleStartReportProblemFlow"
    >
      {{ i18n(translations.reportProblem) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import type { Actions, MachineSend } from '../../../../ActionBar.machine.type'

import translations from './PrimaryActions.translations'
import RefundButton from './components/RefundButton/RefundButton.vue'

const props = defineProps<{
  actions: Actions
  send: MachineSend
}>()

const i18n = useI18n()

function handleStartRefundFlow() {
  props.send('START_REFUND_FLOW')
}

function handleStartShipBackFlow() {
  props.send('START_SHIP_BACK_FLOW')
}

function handleStartReportProblemFlow() {
  props.send('START_REPORT_PROBLEM_FLOW')
}
</script>
